// src/utils/firebase/fetchLatestMetadataInfo.js
import { getStorage, list, ref } from "firebase/storage";
import { firebaseApp } from "../../firebase/firebaseApp";
import {
  isNewerMetadataName,
  metadataTimestampFromName,
} from "./metadataFilename";

/**
 * fetchLatestMetadataInfo
 * -----------------------
 * Returns newest metadata "age" information without downloading the JSON.
 *
 * Strategy:
 *  1) List objects under `user_metadata/{uid}` (paginated).
 *  2) Choose the lexicographically greatest filename (matches your naming scheme).
 *  3) Parse the timestamp from the filename, avoiding an extra metadata call.
 *
 * @param {string} uid
 * @returns {Promise<{ latestMs: number|null, newestName: string|null }|null>}
 */
export async function fetchLatestMetadataInfo(uid) {
  const storage = getStorage(firebaseApp);
  const dirRef = ref(storage, `user_metadata/${uid}`);

  let pageToken = undefined;
  let newestRef = null;

  do {
    // eslint-disable-next-line no-await-in-loop
    const res = await list(dirRef, { maxResults: 1000, pageToken });

    for (const item of res.items) {
      if (!newestRef || isNewerMetadataName(item.name, newestRef.name)) {
        newestRef = item;
      }
    }

    pageToken = res.nextPageToken;
  } while (pageToken);

  if (!newestRef) return null;

  return {
    latestMs: metadataTimestampFromName(newestRef.name),
    newestName: newestRef.name,
  };
}
